module.exports = __webpack_public_path__ + "static/media/initial_hand_lettered_layout_for_shop_logo_2_2017.f847c6a6.webp";